/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const CoBuyReportPage = lazyLoad(
  () => import('./index'),
  module => module.CoBuyReportPage
);
